import dayjs from '../utils/localDayjs'
import {formatNightShiftDate} from './formatNightShiftDate'

export const getDateFormatted = (
  date: string,
  shift: string,
  length: 'short' | 'medium' | 'full' = 'full',
) => {
  const dateObj = dayjs(date)

  if (shift === 'night') {
    switch (length) {
      case 'short':
        return formatNightShiftDate(dateObj, 'short')
      case 'medium':
        return formatNightShiftDate(dateObj, 'medium')
      case 'full':
        return formatNightShiftDate(dateObj, 'full')
    }
  } else {
    switch (length) {
      case 'short':
        return (
          dateObj.locale('fr').format('dd').charAt(0).toUpperCase() +
          dateObj.locale('fr').format('dd').slice(1)
        )
      case 'medium':
        return (
          dateObj.locale('fr').format('ddd D').charAt(0).toUpperCase() +
          dateObj.locale('fr').format('ddd D').slice(1)
        )
      case 'full':
        return (
          dateObj.locale('fr').format('ddd D MMM').charAt(0).toUpperCase() +
          dateObj.locale('fr').format('ddd D MMM').slice(1)
        )
    }
  }
}
